import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <section className="bg-sky-50 py-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 
            className="text-4xl font-bold text-slate-800 mb-4"
            style={{ fontFamily: 'Fredoka, sans-serif' }}
          >
            Privacy Policy
          </h1>
          <p className="text-slate-600">Last updated: January 2026</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="prose prose-slate max-w-none" style={{ fontFamily: 'Quicksand, sans-serif' }}>
          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            1. Introduction
          </h2>
          <p className="text-slate-600 mb-6">
            Welcome to Cartlixs ("we," "our," or "us"). We are committed to protecting your privacy and personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website cartlixs.store and make purchases from our online store.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            2. Information We Collect
          </h2>
          <p className="text-slate-600 mb-4">We collect information that you provide directly to us, including:</p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li><strong>Personal Information:</strong> Name, email address, phone number, shipping address, and billing address when you place an order.</li>
            <li><strong>Payment Information:</strong> We do not store credit card details. Payment processing is handled by secure third-party payment processors.</li>
            <li><strong>Communication Data:</strong> Information you provide when contacting our customer service team.</li>
            <li><strong>Account Information:</strong> If you create an account, we collect your login credentials.</li>
          </ul>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            3. How We Use Your Information
          </h2>
          <p className="text-slate-600 mb-4">We use the information we collect to:</p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li>Process and fulfill your orders</li>
            <li>Communicate with you about your orders and provide customer support</li>
            <li>Send promotional emails and newsletters (with your consent)</li>
            <li>Improve our website and services</li>
            <li>Prevent fraud and maintain security</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            4. Information Sharing
          </h2>
          <p className="text-slate-600 mb-6">
            We do not sell, trade, or rent your personal information to third parties. We may share your information with:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li><strong>Service Providers:</strong> Third-party companies that help us operate our business (shipping carriers, payment processors).</li>
            <li><strong>Legal Requirements:</strong> When required by law or to protect our rights.</li>
            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets.</li>
          </ul>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            5. Data Security
          </h2>
          <p className="text-slate-600 mb-6">
            We implement appropriate technical and organizational security measures to protect your personal information. Our website uses SSL encryption to secure data transmission. However, no method of transmission over the Internet is 100% secure.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            6. Cookies and Tracking
          </h2>
          <p className="text-slate-600 mb-6">
            We use cookies and similar tracking technologies to enhance your browsing experience, analyze website traffic, and personalize content. You can control cookie settings through your browser preferences.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            7. Your Rights
          </h2>
          <p className="text-slate-600 mb-4">You have the right to:</p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your information</li>
            <li>Opt-out of marketing communications</li>
            <li>Request data portability</li>
          </ul>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            8. Children's Privacy
          </h2>
          <p className="text-slate-600 mb-6">
            Our website is not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13. If you believe we have collected information from a child under 13, please contact us immediately.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            9. Changes to This Policy
          </h2>
          <p className="text-slate-600 mb-6">
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
          </p>

          <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>
            10. Contact Us
          </h2>
          <p className="text-slate-600 mb-4">
            If you have any questions about this Privacy Policy, please contact us:
          </p>
          <ul className="list-none text-slate-600 space-y-2">
            <li><strong>Email:</strong> support@cartlixs.store</li>
            <li><strong>Phone:</strong> +1-888-435-6822</li>
            <li><strong>Address:</strong> 192 A 22nd St #4699, New York, NY 30272</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
